import React, { forwardRef } from 'react';
import './ScrollProgressBar.css';

const ScrollProgressBar = forwardRef((props, ref) => {
  return (
    <div className="scroll-progress-bar">
      <div className="scroll-progress" ref={ref} />
    </div>
  );
});

ScrollProgressBar.displayName = 'ScrollProgressBar';

export default ScrollProgressBar;